// @ts-strict-ignore
export interface ImageProps {
  height: number;
  width: number;
  url: string;
}

export const imageDefaults: ImageProps = {
  height: null,
  width: null,
  url: ""
};

export interface ImageObjectProps {
  mobile: ImageProps;
  tablet: ImageProps;
  desktop: ImageProps;
  alt: string;
}

export const imageObjectDefaults: ImageObjectProps = {
  mobile: imageDefaults,
  tablet: imageDefaults,
  desktop: imageDefaults,
  alt: ""
};

export const contentfulImageObjectToImage = (imageObject) => ({
  mobile: contentfulImageToImage(imageObject?.fields?.mobileImage),
  tablet: contentfulImageToImage(imageObject?.fields?.tabletImage),
  desktop: contentfulImageToImage(imageObject?.fields?.desktopImage),
  alt: imageObject?.fields?.alt
});

export const contentfulImageToImage = (image) => ({
  height: image?.fields?.file?.details?.image?.height || imageDefaults.height,
  width: image?.fields?.file?.details?.image?.width || imageDefaults.width,
  url: image?.fields?.file?.url || imageDefaults.url
});
